module.exports = __webpack_public_path__ + "static/media/KGPrimaryDots.9f3e3eb6.ttf";